import ValidationResult, { error, VALID } from "./ValidationResult";
import ParameterValue from "../api/models/test-series/ParameterValue";
import EnumParameterValue from "../api/models/test-series/EnumParameterValue";
import NumberParameterValue from "../api/models/test-series/NumberParameterValue";
import TextParameterValue from "../api/models/test-series/TextParameterValue";
import Parameter from "../api/models/test-series/Parameter";
import NumberParameter from "../api/models/test-series/NumberParameter";
import EnumParameter from "../api/models/test-series/EnumParameter";

export function handleParameterValue<T>(
  parameterValue: ParameterValue,
  decision: {
    enum: (value: EnumParameterValue) => T;
    number: (value: NumberParameterValue) => T;
    text: (value: TextParameterValue) => T;
  },
): T {
  if (parameterValue.type === "NUMBER") {
    return decision.number(parameterValue as NumberParameterValue);
  }
  if (parameterValue.type === "ENUM") {
    return decision.enum(parameterValue as EnumParameterValue);
  }
  if (parameterValue.type === "TEXT") {
    return decision.text(parameterValue as TextParameterValue);
  }
  throw new Error("illegal state");
}

export function handleParameter<T>(
  parameter: Parameter,
  decision: {
    enum: (enumParameter: EnumParameter) => T;
    number: (numberParameter: NumberParameter) => T;
    text: (textParameter: Parameter) => T;
  },
): T {
  if (parameter.type === "NUMBER") {
    return decision.number(parameter as NumberParameter);
  }
  if (parameter.type === "ENUM") {
    return decision.enum(parameter as EnumParameter);
  }
  if (parameter.type === "TEXT") {
    return decision.text(parameter);
  }
  throw new Error("illegal state");
}

export function toParameterValue(parameter: Parameter): ParameterValue {
  return handleParameter<ParameterValue>(parameter, {
    number: (numberParameter) => {
      const numberValue: NumberParameterValue = {
        parameter: numberParameter,
        value: null,
        unitCode: null,
        type: "NUMBER",
      };
      return numberValue;
    },
    enum: (enumParameter) => {
      const enumValue: EnumParameterValue = {
        parameter: enumParameter,
        value: null,
        type: "ENUM",
      };
      return enumValue;
    },
    text: (textParameter) => {
      const textValue: TextParameterValue = {
        parameter: textParameter,
        value: null,
        type: "TEXT",
      };
      return textValue;
    },
  });
}

export default class ParameterValueValidator {
  static validate(parameterValue: ParameterValue): ValidationResult {
    return handleParameterValue<ValidationResult>(parameterValue, {
      number: (value) => {
        const valid = parameterValue.uncontrolled ? true : !!value.value?.toString() && !!value.unitCode;
        return valid ? VALID : error(`Please enter a value for "${parameterValue.parameter.name}".`);
      },
      enum: (value) => {
        const valid = parameterValue.uncontrolled ? true : !!value.value;
        return valid ? VALID : error(`Please select a value for "${parameterValue.parameter.name}".`);
      },
      text: (value) => {
        const valid = parameterValue.uncontrolled ? true : !!value.value;
        return valid ? VALID : error(`Please enter a value for "${parameterValue.parameter.name}".`);
      },
    });
  }
}
